import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { apiXToken } from '../../configs/api.config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const authTokenData = authService.authTokenData();

  const headers = req.headers.append('X-API-Token', apiXToken).append('Accept', 'application/json');

  if (authTokenData && authTokenData.token) {
    req = req.clone({
      headers: headers.append('Authorization', `Bearer ${authTokenData.token}`),
    });
  } else {
    req = req.clone({ headers });
  }

  return next(req);
};
